import { render } from "./ConsentDaata.vue?vue&type=template&id=722d2caf&scoped=true"
import script from "./ConsentDaata.vue?vue&type=script&lang=js"
export * from "./ConsentDaata.vue?vue&type=script&lang=js"

import "./ConsentDaata.vue?vue&type=style&index=0&id=722d2caf&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-722d2caf"]])

export default __exports__